import React from "react";

export default function SearchIcon({
  size = 18,
  color = "#000000",
  strokeWidth = 2.5,
  className,
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeMiterlimit="10"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      role="img"
      {...props}
    >
      <circle cx="8.87" cy="8.88" r="7" />
      <line x1="19" y1="19" x2="13.38" y2="13.38" />
    </svg>
  );
}
